@import 'common/stylesheets/mixins/common.styl'

.container
  :global(li)
    list-style-type disc
  :global(ul)
    padding-left 16px

  &.truncate
    truncate-text()
